export default "__VITE_ASSET__dbeda708__"